var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1000px",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.orderDatalist
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "detailHead" }, [
                    _c(
                      "div",
                      { staticClass: "acea-row row-between headerBox" },
                      [
                        _c("div", { staticClass: "full" }, [
                          _c("div", { staticClass: "order_icon" }, [
                            _c("span", {
                              staticClass: "iconfont icon-dingdan",
                            }),
                          ]),
                          _c("div", { staticClass: "text" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.orderDatalist.serviceType === 1
                                      ? "上门服务"
                                      : "到店服务"
                                  ) +
                                  " -- " +
                                  _vm._s(
                                    _vm.orderDatalist.allocateType === 0
                                      ? "未分配"
                                      : _vm.orderDatalist.allocateType === 1
                                      ? "派单"
                                      : "抢单"
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "mr20" }, [
                                _vm._v(
                                  "工单号：" +
                                    _vm._s(_vm.orderDatalist.workOrderNo)
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.orderDatalist.refundStatus === 0,
                                expression: "orderDatalist.refundStatus===0",
                              },
                            ],
                            staticClass: "acea-row justify-content",
                          },
                          [
                            _vm.orderDatalist.serviceStatus === 1 &&
                            _vm.checkPermi(["merchant:workOrder:assign"])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDispatch(1)
                                      },
                                    },
                                  },
                                  [_vm._v("派单")]
                                )
                              : _vm._e(),
                            (_vm.orderDatalist.serviceStatus === 2 ||
                              _vm.orderDatalist.serviceStatus === 3) &&
                            _vm.checkPermi(["merchant:workOrder:reassign"])
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "0" },
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDispatch(2)
                                      },
                                    },
                                  },
                                  [_vm._v("改派")]
                                )
                              : _vm._e(),
                            _vm.orderDatalist.serviceStatus < 3 &&
                            _vm.checkPermi([
                              "merchant:workOrder:updateAgreement",
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "debounceClick",
                                        rawName: "v-debounceClick",
                                        value: _vm.handleRescheduling,
                                        expression: "handleRescheduling",
                                      },
                                    ],
                                    staticStyle: { "margin-left": "0" },
                                    attrs: { size: "small", type: "primary" },
                                  },
                                  [_vm._v("改约")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("ul", { staticClass: "list" }, [
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("工单状态"),
                        ]),
                        _c("div", { staticClass: "color-warning" }, [
                          _vm.orderDatalist.refundStatus === 2
                            ? _c("span", [_vm._v("已退款")])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("serviceStatusFilter")(
                                      _vm.orderDatalist.serviceStatus
                                    )
                                  )
                                ),
                              ]),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("预约时间"),
                        ]),
                        _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.orderDatalist.reservationDate)),
                          ]),
                          _c("span", { staticClass: "ml10" }, [
                            _vm._v(
                              _vm._s(_vm.orderDatalist.reservationTimeSlot)
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-tabs",
                    {
                      attrs: { type: "border-card" },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "基本信息", name: "detail" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "detailSection",
                              staticStyle: { border: "none" },
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("预约信息"),
                              ]),
                              _c("ul", { staticClass: "list" }, [
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("联系人："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(_vm._s(_vm.orderDatalist.userName)),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("联系电话："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(_vm._s(_vm.orderDatalist.userPhone)),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("预约时间："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist.reservationDate
                                        )
                                      ),
                                    ]),
                                    _c("span", { staticClass: "ml10" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist.reservationTimeSlot
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.orderDatalist.serviceType === 1,
                                      expression:
                                        "orderDatalist.serviceType === 1",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("上门地址："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.orderDatalist.userAddress) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "detailSection" },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("商品信息"),
                              ]),
                              _c(
                                "el-table",
                                {
                                  staticClass: "mt20 orderDetailList",
                                  attrs: {
                                    data: _vm.productList,
                                    size: "small",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品信息",
                                      "min-width": "350",
                                      "show-overflow-tooltip": true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "acea-row row-middle",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "demo-image__preview mr15",
                                                    },
                                                    [
                                                      _c("el-image", {
                                                        attrs: {
                                                          src: scope.row.image,
                                                          "preview-src-list": [
                                                            scope.row.image,
                                                          ],
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "300px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "line1 mb10",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .productName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "line1 color-909399 line-heightOne",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "规格：" +
                                                              _vm._s(
                                                                scope.row.sku
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      469597091
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品售价",
                                      "min-width": "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "acea-row row-middle",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line1" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            scope.row.price
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3355191556
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "购买数量",
                                      "min-width": "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "acea-row row-middle",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line1" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            scope.row.payNum
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1311105687
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("买家留言"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.userRemark
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("工单备注"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.remark
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm.reservationFormData.length
                            ? _c("div", { staticClass: "detailSection" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("自定义留言"),
                                ]),
                                _c(
                                  "ul",
                                  {},
                                  _vm._l(
                                    _vm.reservationFormData,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        { key: index, staticClass: "item" },
                                        [
                                          _c("system-from-info", {
                                            attrs: { item: item },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "服务信息", name: "goods" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "detailSection",
                              staticStyle: { border: "none" },
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("服务信息"),
                              ]),
                              _c("ul", { staticClass: "list" }, [
                                _c("li", { staticClass: "item" }, [
                                  _c("div", {}, [_vm._v("服务人员：")]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist.serviceStaff
                                          ? _vm.orderDatalist.serviceStaff.name
                                          : "-"
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", {}, [_vm._v("联系电话：")]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist.serviceStaff
                                          ? _vm.orderDatalist.serviceStaff.phone
                                          : "-"
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", {}, [_vm._v("开始服务时间：")]),
                                  _c("div", { staticClass: "value" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist.serviceStartTime ||
                                            "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", {}, [_vm._v("结束服务时间：")]),
                                  _c("div", { staticClass: "value" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist.serviceEndTime ||
                                            "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", {}, [_vm._v("服务时长：")]),
                                  _c("div", { staticClass: "value" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist.serviceDuration
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm.orderDatalist.collaboratorStaffs &&
                                _vm.orderDatalist.collaboratorStaffs.length
                                  ? _c(
                                      "li",
                                      _vm._l(
                                        _vm.orderDatalist.collaboratorStaffs,
                                        function (item) {
                                          return _c(
                                            "div",
                                            {
                                              key: item.id,
                                              staticClass: "item",
                                            },
                                            [
                                              _c("div", {}, [
                                                _vm._v("协作者："),
                                              ]),
                                              _c(
                                                "div",
                                                { staticClass: "value" },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.name)),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm.orderDatalist.serviceType === 1
                            ? _c("div", { staticClass: "detailSection" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("打卡信息"),
                                ]),
                                _c("ul", { staticClass: "list" }, [
                                  _c("li", { staticClass: "item item100" }, [
                                    _c("div", [_vm._v("打卡备注：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("filterEmpty")(
                                              _vm.orderDatalist.clockInRemark
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "li",
                                    { staticClass: "item item100" },
                                    [
                                      _c("div", [_vm._v("打卡照片：")]),
                                      _vm.orderDatalist.clockInPhoto
                                        ? _vm._l(
                                            _vm.orderDatalist.clockInPhoto.split(
                                              ","
                                            ),
                                            function (item, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "flex",
                                                },
                                                [
                                                  _c("el-image", {
                                                    staticStyle: {
                                                      width: "40px",
                                                      height: "40px",
                                                      "margin-right": "12px",
                                                    },
                                                    attrs: {
                                                      src: item,
                                                      "preview-src-list": [
                                                        item,
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        : _c("div", [_vm._v("--")]),
                                    ],
                                    2
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.orderDatalist.serviceType === 1 &&
                          _vm.serviceEvidenceForm.length
                            ? _c("div", { staticClass: "detailSection" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("服务过程留凭"),
                                ]),
                                _c(
                                  "ul",
                                  { staticClass: "list" },
                                  _vm._l(
                                    _vm.serviceEvidenceForm,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        { key: index, staticClass: "item" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "lang",
                                              attrs: { title: item.title },
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                item.title.includes(":")
                                                  ? ""
                                                  : "："
                                              )
                                            ),
                                          ]),
                                          !Array.isArray(item.value)
                                            ? _c(
                                                "div",
                                                { staticClass: "value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("filterEmpty")(
                                                        item.value
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "flex conter" },
                                                [
                                                  item.value
                                                    ? _vm._l(
                                                        item.value,
                                                        function (pic, idx) {
                                                          return _c(
                                                            "div",
                                                            { key: idx },
                                                            [
                                                              pic.includes(
                                                                "http"
                                                              )
                                                                ? _c(
                                                                    "el-image",
                                                                    {
                                                                      staticClass:
                                                                        "pictrue",
                                                                      attrs: {
                                                                        src: pic,
                                                                        "preview-src-list":
                                                                          [pic],
                                                                      },
                                                                    }
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-14px fontColor333 ml-5px acea-row row-middle mr5",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            pic
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  idx <
                                                                                  item
                                                                                    .value
                                                                                    .length -
                                                                                    1,
                                                                                expression:
                                                                                  "idx < item.value.length - 1",
                                                                              },
                                                                            ],
                                                                          staticStyle:
                                                                            {
                                                                              "margin-left":
                                                                                "6px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "-"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                    : [_vm._v(" - ")],
                                                ],
                                                2
                                              ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("dialogDispatch", {
        ref: "dialogDispatchRef",
        attrs: { workOrderNoList: [_vm.workOrderNo] },
        on: { selectStaff: _vm.selectStaff },
      }),
      _c("dialogReschedule", {
        ref: "dialogRescheduleRef",
        attrs: {
          orderDetailList: _vm.orderDatalist,
          productList: _vm.productList,
          workOrderNoList: [_vm.workOrderNo],
        },
        on: { selectStaff: _vm.selectStaff },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }